import { setAuthorization } from 'utils/api';

export default ({ getState }) => {
  setAuthorization(getState().auth.token);
  return next => action => {
    next(action);
    setAuthorization(getState().auth.token);
  };
};
